export default __webpack_public_path__ + "static/media/YanoneKaffeesatz-ExtraLight.81b877e3.ttf";